import React, { useContext } from 'react';
import { useWindowSize } from 'react-use';
import ThemeContext from '../../contexts/themeContext';

const WrapperOverlay = () => {
	const { width } = useWindowSize();
	const { asideStatus, setAsideStatus, setLeftMenuStatus, setRightMenuStatus, setAsideSubStatus } =
		useContext(ThemeContext);

	// overlay가 보여지는 조건
	const showOverlay =
		asideStatus &&
		width < process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE &&
		location.pathname !== '/login' &&
		location.pathname !== '/change-company';

	if (!showOverlay) return null;

	return (
		<div
			role='presentation'
			onClick={() => {
				setAsideStatus(false);
				setAsideSubStatus(false);
				setLeftMenuStatus(false);
				setRightMenuStatus(false);
			}}
			className='wrapper-overlay'
		/>
	);
};

export default WrapperOverlay;